import { addDays, isAfter, isEqual } from 'date-fns';
import dayjs from 'dayjs';

export const isValidMaxDecimalPlaces = (
  value: number | null | undefined,
  maxDecimals: number
): boolean => {
  if (!value) {
    return true;
  }
  if (value % 1 === 0) {
    return true;
  }
  return value.toString().split('.')[1].length <= maxDecimals;
};

export const convertToNullWhenNaN = (value) =>
  Number.isNaN(value) ? null : value;

export const convertDateStringToDate = (value: string) => {
  return dayjs(value, 'DD-MM-YYYY').isValid()
    ? dayjs(value, 'DD-MM-YYYY').toDate()
    : null;
};
export const dateIsEqualOrIsAfterNextDay = (
  to: Date | null,
  schema
): boolean => {
  if (!to || !schema.parent.from) {
    return true;
  }

  const nextDay = addDays(schema.parent.from, 1);
  return isEqual(to, nextDay) || isAfter(to, nextDay);
};

export const parseDateString = (value, originalValue) => {
  if (!originalValue) return null;

  if (dayjs(originalValue).isValid()) return dayjs(originalValue).toDate();

  const parsedDate = dayjs(originalValue, 'DD-MM-YYYY');
  if (parsedDate.isValid()) return parsedDate.toDate();

  // return null to handle yup's required if date is not in the right format
  return dayjs(originalValue).isValid() ? dayjs(originalValue).toDate() : null;
};
